var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "filter",
    { attrs: { width: "100%", height: "100%" } },
    [
      _c("feTurbulence", {
        attrs: {
          baseFrequency: "0.02 0.03",
          result: "NOISE",
          numOctaves: _vm.octaves,
          id: "turbulence"
        }
      }),
      _c("feDisplacementMap", {
        attrs: { in: "SourceGraphic", in2: "NOISE", scale: "20" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }